import {Action, Mutation, getModule, Module} from 'vuex-module-decorators';
import store from '@/store';
import {UserData} from '@/views/administration/users/interfaces';
import {httpClient} from '@/api/baseApi';
import authModule from '../authModule';
import {config} from 'vuex-module-decorators';
import {EntityModule} from './entityModule';
config.rawError = true;

/*
    Динамический модуль хранилища vuex для работы с пользователями
*/

const moduleName = 'userModule';

function transformGet(elem: any): UserData {
  return {
    id: elem.id,
    login: elem.login,
    name: elem.name,
    email: elem.email,
    position: elem.position,
    phone: elem.phone,
    rolesDescription: elem.roles_description,
    roles: [],
  };
}

function transformCreateEdit(elem: any): UserData {
  const roles = elem.roles.map((elem: any) => ({
    roleId: elem.role_id,
    roleDescription: elem.role_description,
    bind: elem.bind,
  }));
  return {...elem, roles};
}

function transformSave(model: UserData): any {
  const roles = model.roles.map((elem: any) => ({
    role_id: elem.roleId,
    role_description: elem.roleDescription,
    bind: elem.bind,
  }));
  return {...model, roles};
}

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class UsersModule extends EntityModule {
  googleAuthKeyName = localStorage.getItem('googleAuthKeyName');

  protected routeName = 'users';

  get all(): UserData[] {
    return super.all as UserData[];
  }

  //Получение списка объектов с сервера
  @Action
  public async fetchAll() {
    return await super.fetchAll(transformGet);
  }

  //Получение модели для создания объекта
  @Action
  public async create(): Promise<{data: UserData}> {
    return super.create(transformCreateEdit) as Promise<{data: UserData}>;
  }

  //Получение модели для редактирования объекта
  @Action
  public async edit(id: any): Promise<{data: UserData}> {
    return super.edit(id, transformCreateEdit) as Promise<{data: UserData}>;
  }

  //Создание/реактирование объекта
  @Action
  public async save(model: UserData) {
    return super.save(model, transformSave);
  }

  @Mutation
  setGoogleAuthKeyName(state: string) {
    this.googleAuthKeyName = state;
    localStorage.setItem('googleAuthKeyName', state);
  }

  //Получение имени ключа гугл аккаунта
  get getGoogleAuth() {
    return this.googleAuthKeyName;
  }

  /*
  Получить ссылку для привязки гугл-аккаунта
  */
  @Action
  async startFlow() {
    const {data} = await httpClient.get('/google_accounts/start_flow/');
    return data;
  }

  /*
  Отправить код от google и привязать аккаунт гугл к учетной записи
  */
  @Action
  async submitCode(code: string) {
    const keyFilename = `${authModule.loggedInUser}.key.json`;
    const {data} = await httpClient.post('/google_accounts/submit_code/', {
      code,
      key_filename: keyFilename,
    });
    if (data.status === 'ok') {
      this.context.commit('setGoogleAuthKeyName', keyFilename);
      return true;
    }
    return false;
  }
}

export default getModule(UsersModule);
